import { useSamplesBudgetBalanceQuery } from '../queries/useSamplesBudgetBalanceQuery'

export const useSamplesBudgetBalance = () => {
  const { samplesBudgetBalanceQuery } = useSamplesBudgetBalanceQuery()

  const getSamplesBudgetBalance = () => {
    if (samplesBudgetBalanceQuery.isLoading) return undefined

    if (!samplesBudgetBalanceQuery.data?.balance) {
      return { value: 0, currency: 'USD' }
    }

    return samplesBudgetBalanceQuery.data.balance
  }

  const getSamplesBudgetBalanceWithIncentive = () => {
    if (samplesBudgetBalanceQuery.isLoading) return undefined

    if (!samplesBudgetBalanceQuery.data?.balanceWithIncentive) {
      return { value: 0, currency: 'USD' }
    }

    return samplesBudgetBalanceQuery.data.balanceWithIncentive
  }

  return {
    samplesBudgetBalance: getSamplesBudgetBalance(),
    samplesBudgetBalanceWithIncentive: getSamplesBudgetBalanceWithIncentive(),
  }
}
